export default "__VITE_ASSET__Blq6oGAW__"